import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import all from './all';
import accepted from './accepted';
import submitted from './submitted';
import pending from './pending';
import requests from './requests';
import Rbac from '../../../components/Rbac';

const Withdraws = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      {Rbac.hasPermission('view_withdraws-list') ?
        <Redirect exact from={`${match.url}/`} to={`${match.url}/waiting`}/> :
        <Redirect exact from={`${match.url}/`} to={`${match.url}/unconfirmedRequests`}/>
      }
      <Route path={`${match.url}/all`} component={all}/>
      <Route path={`${match.url}/waiting`} component={accepted}/>
      <Route path={`${match.url}/registered`} component={submitted}/>
      <Route path={`${match.url}/pending`} component={pending}/>
      <Route path={`${match.url}/unconfirmedRequests`} component={requests}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Withdraws;
